enum Commands {
  connect,
  idpersonnage,
  // action, Disabled for now
  asrt,
  nomposte,
  sauvegarde,
  habitations,
  sante,
  forme,
  statut,
  credits,
  hackHistoriqueTaxeCercle,
}

export default Commands;
